import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

/**
 * Composición CENTRADA idéntica a ChangeStateModal (auditoría modales
 * 2026-07-06): icono de alerta → título centrado → campos centrados →
 * botones. Editar la causa es el MISMO gesto semántico que "cambiar
 * estado" (chip → modal con efectos), así que comparte su lenguaje visual
 * — no el de un formulario alineado a la izquierda.
 */
export const ContainerForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 2.5rem 6.35rem;
  width: 100%;
  /* Debe caber en una pantalla de 24" con el chrome del navegador
     (feedback usuario 2026-07-14); si aun así no cabe, scroll interno
     en vez de desbordar el viewport. */
  max-height: 92vh;
  overflow-y: auto;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: 2.5rem 2.4rem;
    gap: 2rem;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2.4rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  width: 100%;
`;

/* El textarea de detalle ocupa TODO el ancho del cuerpo (feedback usuario
   2026-07-06): el Container interno del InputTextArea encoge al centro del
   Section si no se estira explícitamente. */
export const TextAreaWrap = styled.div`
  width: 100%;

  & > div {
    width: 100%;
  }

  /* El min-height por defecto del InputTextArea (21rem) desborda el modal
     en alto; 10rem basta para una nota y sigue siendo redimensionable. */
  & textarea {
    min-height: 10rem;
  }
`;

/* Aviso de consecuencias (desvinculación / crear At.) — acento ámbar de
   theme. Texto a la izquierda dentro de la caja aunque el modal centre. */
export const ConsequenceNotice = styled.p`
  margin: 0;
  width: 100%;
  padding: 1rem 1.4rem;
  border-left: 0.4rem solid ${({ theme }) => theme.colors.secondaryOrange};
  background-color: ${({ theme }) => theme.colors.greyVerySoft};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${({ theme }) => theme.fontSize.S};
  text-align: left;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.m};
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;

export const ActionButton = styled(MainButton)`
  min-width: 13.4rem;
  justify-content: center;
`;
